import { CSSProperties, ReactElement, useState } from "react";
import { Card, IconButton, styled } from "@mui/material";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Detail from "../dialogs/detail";
import { IDetailProps } from "../../types";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface ICardBaseProps {
  title: string;
  style?: CSSProperties;
  children: ReactElement | ReactElement[];
  detail: IDetailProps | undefined | null;
}

const CardStyled = styled(Card)(({ theme }) => ({
  margin: "0.5em",
  flexGrow: 1,
  minWidth: "200px",
  height: "190px",
  [theme.breakpoints.down("md")]: {
    minWidth: "180px !important",
    fontSize: "0.7em"
  },
  [theme.breakpoints.down("xs")]: {
    minWidth: "100px !important",
    fontSize: "0.7em"
  }
}));

const CardBase = ({ title, children, detail, style }: Partial<ICardBaseProps>): ReactElement => {
  const [openDetail, setOpenDetail] = useState(false);

  return(
    <CardStyled style={style}>
      <CardHeader title={title} sx={{ padding: "0.5em" }}
        action={
          detail && <IconButton aria-label="settings" onClick={() => setOpenDetail(!openDetail)}>
            <MoreVertIcon />
          </IconButton>
        }/>
      <CardContent sx={{ height: "100%", padding: "0.5em" }}>
        {children}
      </CardContent>
      {openDetail && detail &&
      <Detail title={detail.title} closed={() => setOpenDetail(false)}>
        {detail.children}
      </Detail>
      }
    </CardStyled>
  );
};

export default CardBase;
